import ky from "ky";
import { env } from "./env";

export const apiClient = ky.create({
	prefixUrl: env.NEXT_PUBLIC_API_URL,
	cache: "no-cache",
	headers: {
		"Content-Type": "application/json",
		Accept: "application/json",
	},
	hooks: {
		beforeError: [
			async (error) => {
				if (process.env.NODE_ENV !== 'production') {
					console.log("http errors", error.message);
				}
				return error
			},
		],
		beforeRequest: [
			request => {
				if (process.env.NODE_ENV !== 'production') {
					console.log('Requête envoyée:', request.url, request.method);
				}
			}
		],
		afterResponse: [
			(_request, _options, response) => {
				if (process.env.NODE_ENV !== 'production') {
					console.log('Réponse reçue:', response.status, response.url);
				}
			}
		]
	},
	credentials: 'include',
})